import './FinancialResults_AnnualReport.css';

import useMeta from "../../../hooks/useMeta";

import { Link } from "react-router-dom";

import Footer from "../../../CommonComponent/Footer/footer";
import Navbar from "../../../CommonComponent/Navbar/Navbar";
import NotificationBar from "../../../CommonComponent/Notification/NotificationBar";

const FinancialResults_AnnualReports = () => {

    const data = [
        { title: "Financial Results Standalone and Consolidated for the Year Ended on 31.03.2026", url: "/Documnets/FR_March26.pdf" },
        { title: "Financial Results Standalone and Consolidated for the Half year Ended on 30.09.2025", url: "/Documnets/FR_Sept25_Revised.pdf" },
        { title: "Intimation Board Meeting 12.11.2025", url: "/Content/Intimation_BM_12112025_.pdf" },
        { title: "Financial Results Standalone and Consolidated for the Year Ended on 31.03.2025", url: "/Documnets/MDL_30052025195831_FR_MDL_31032025.pdf" },
        { title: "Intimation Board Meeting 30.05.2025", url: "/Documnets/Intimation_BM_30052025_signed.pdf" },
        { title: "Financial Results Standalone and Consolidated for the Half Year Ended on 30.09.2024", url: "/Documnets/Financial-Results.pdf" },
        { title: "Intimation Board Meeting 11.11.2024", url: "/Documnets/Intimation_BM_11112024Signed.pdf" },
        { title: "Financial Results Standalone and Consolidated for the Year Ended on 31.03.2024", url: "/Documnets/Financial_Results_for_the_year_ended_31032024.pdf" },
        { title: "Intimation Board Meeting 30.05.2024", url: "/Documnets/IntimationBM-30052024Signed.pdf" },
        { title: "Financial Results Standalone and Consolidated for the Year Ended on 30.09.2023", url: "/Documnets/Financial-Results-Standalone-and-Consolidated-for-the-Year-Ended-on-30.09.2023.pdf" },
        { title: "Intimation Board Meeting 10.11.2023", url: "/Documnets/Intimation-Board-Meeting-10.11.2023.pdf" },
        { title: "Notice of BM- 10.11.2023", url: "/Documnets/Notice-of-BM-10.11.2023.pdf" },
        { title: "Financial Results Standalone and Consolidated for the Year Ended on 31.03.2023", url: "/Documnets/FinancialResult_NSE.pdf" },
        { title: "Intimation Board Meeting 31.03.2023", url: "/Documnets/IntimationofBM.pdf" },
        { title: "Notice of BM_29-May-23", url: "/Documnets/BM_29-May-23.pdf" },
        { title: "Financial Results Standalone and Consolidated for the Half Year Ended on 30.09.2022", url: "/Documnets/FinancialResult_NSE_Searchable.pdf" },
        { title: "Intimation Board Meeting 30.09.2022", url: "/Documnets/Intimation_BM_Marvel_30.09.2022.pdf" },
        { title: "Notice of BM_14-Nov-22", url: "/Documnets/BoardMeetingNotice.pdf" },
        { title: "Financial Results Standalone and Consolidated for the Year Ended on 31.03.2022", url: "/Documnets/" },
        { title: "Intimation Board Meeting 31.03.2022", url: "/Documnets/Intimation_BM_Marvel_21052022.pdf" },
        { title: "Notice of BM_30-May-22", url: "/Documnets/Notice_of_BM_30-May-22.pdf" },
        { title: "Unaudited Consolidated Financial Results for Half Year Ended 30.09.2021", url: "/Documnets/Unaudited-Financial-Results-for-Half-year-Ended-30.09.2021.pdf" },
        { title: "Intimation Board Meeting 30.09.2021", url: "/Documnets/f.r._mdl.pdf" },
        { title: "Notice of BM_14-Nov-21", url: "/Documnets/Notice_of_BM_14-Nov-21.pdf" },
        { title: "Financial Results Standalone and Consolidated for the Year Ended on 31.03.2021", url: "/Documnets/f.r._mdl_march_ 2021.pdf" },
        { title: "Intimation Board Meeting 31.03.2021", url: "/Documnets/Intimation_BM_FR_March2021.pdf" },
        { title: "Notice of BM_30-Jun-21", url: "/Documnets/Notice_of_BM_30-Jun-21.pdf" },
        { title: "Unaudited Consolidated Financial Results for Half Year Ended 30.09.2020", url: "/Documnets/financial-result-30.09.2020.pdf" },
        { title: "Intimation Board Meeting 30.09.2020", url: "/Documnets/intimation_board_meeting.pdf" },
        { title: "Notice of BM_14-Nov-20", url: "/Documnets/Notice_of_BM_14-Nov-20.pdf" },
        { title: "Financial Results Standalone and Consolidated for the Year End 31.03.2020", url: "/Documnets/fin_res_standalone_&_consolicated.pdf" },
        { title: "Intimation Board Meeting 31.03.2020", url: "/Documnets/Intimation_BM_FR_March2020.pdf" },
        { title: "Notice of BM_30-Jul-20", url: "/Documnets/Notice_of_BM_30-Jul-20.pdf" },
        { title: "Unaudited Consolidated Financial Results for Half Year Ended on 30.09.2019", url: "/Documnets/unaudiated_consolidated_financial_resutls.pdf" },
        { title: "Intimation Board Meeting 30.09.2019", url: "/Documnets/Intimation_BM_FR_Sep2019.pdf" },
        { title: "Notice of BM_14-Nov-19", url: "/Documnets/Notice_of_BM_14-Nov-19.pdf" },
        { title: "Financial Results Standalone and Consolidated for the Year Ended on 31.03.2019", url: "/Documnets/financial_results_marvel_march_2019.pdf" },
        { title: "Intimation Board Meeting 31.03.2019", url: "/Documnets/Intimation_BoardMeeting_Marvel_30052019.pdf" },
        { title: "Notice of BM_30-May-19", url: "/Documnets/Notice_of_BM_30-May-19.pdf" },
        { title: "Impact of Covid-19 on Business Operation of Company 31.03.2019", url: "/Documnets/impect_of_covid-19.pdf" },
        { title: "Standalone Unaudited Financial Results for Half Year Ended on 30.09.2018", url: "/Documnets/Standalone-Unaudited-Financial-Results-for-Half-Year-ended-on-September-30-2018.pdf" },
        { title: "Intimation Board Meeting 30.09.2018", url: "/Documnets/Intimation_BM_FR_Sep2018.pdf" },
        { title: "Notice of BM_14-Nov-18", url: "/Documnets/Notice_of_BM_14-Nov-18.pdf" },
        { title: "Notice of BM_28-May-18", url: "/Documnets/Notice_of_BM_28-May-18.pdf" },
        { title: "Standalone Audited Balance Sheet for the Year Ended 31.03.2018", url: "/Documnets/Marvel_Financials_31032018.pdf" },
        { title: "Notice of Board Meeting for Approval of Financial Statements 31.03.2018", url: "/Documnets/Notice_of_Board_Meeting.pdf" },
        { title: "Standalone Audited Balance Sheet for Half Year Ended 30.09.2017", url: "/Documnets/Audit-Report-April-to-Sept.-2017.pdf" },
        { title: "Standalone Audited Balance Sheet for the Year Ended 31.03.2017", url: "/Documnets/Audit-Report-F.Y.-2016-17.pdf" }
    ];

    function CheckValue(index) {
        return (index % 2 !== 0) ? true : false
    }

    useMeta({
        title: 'Financial Results | Marvel Blinds',
        description: "Annual Report Financial Results Standalone and Consolidated for the Year Ended on 31.03.2025 Intimation Board Meeting 30.05.2025 Financial Results Standalone and Consolidated for the Half Year Ended on 30.09.2024 Intimation Board Meeting 11.11.2024 Financial Results Standalone and Consolidated for the Year Ended on 31.03.2024 Intimation Board Meeting 30.05.2024 Financial Results Standalone and Consolidated for […]",
        canonical: `${process.env.REACT_APP_WEBSITE_URL}/financial-results`,
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'Financial Results',
            description:
                "Annual Report   Financial Results Standalone and Consolidated for the Year Ended on 31.03.2025 Intimation Board Meeting 30.05.2025 Financial Results Standalone and Consolidated for the Half Year Ended on 30.09.2024 Intimation Board Meeting 11.11.2024 Financial Results Standalone and Consolidated for the Year Ended on 31.03.2024 Intimation Board Meeting 30.05.2024 Financial Results Standalone and Consolidated for […]",
            url: `${process.env.REACT_APP_WEBSITE_URL}/financial-results`,
            site_name: 'Marvel Blinds',
        },
    });


    return (
        <>
            <Navbar />
            <NotificationBar />
            <div className="FRAR_pg_container">
                <h1 className="FRAR_pg_title">FINANCIAL RESULTS</h1>
                <Link to="/annual-report-agm" className="Annual_report">Annual Report</Link>
                <table className="FRAR_pg_table">
                    <tbody>
                        {data.map((item, index) => (
                            <tr key={index}>
                                <td className={CheckValue(index) === true ? 'Border-none' : 'even-row'}>
                                    <Link target="__blank " to={item.url || "#"}>
                                        {item.title}
                                    </Link>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <Footer />
        </>
    );
}

export default FinancialResults_AnnualReports